import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuestionType, RouterLinks} from '../../../constants';
import {Question} from '../../../models/underwriter.model';
import {FlowPlayerService} from '../../../services/flow-player.service';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../state/question-flow-session.query';
import {ShoppingCartQuery} from '../../state/shopping-cart-query';

declare var $: any;

@Component({
    selector: 'app-item-update-modal',
    templateUrl: './item-update-modal.component.html',
    styleUrls: ['./item-update-modal.component.scss'],
    standalone: false
})
export class ItemUpdateModalComponent implements OnInit {

  session_details: any;
  questions: Question[];
  cart_item: any;
  question: Question;
  loading = false;
  isSavingData = false;
  childrenQuestions: Question[] = [];
  QuestionType = QuestionType;

  constructor(
    private router: Router,
    private sessionQuery: QuestionFlowSessionQuery,
    private globalQuestionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private shoppingCartQuery: ShoppingCartQuery) {
  }

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    const cart_id = this.shoppingCartQuery.getActiveId();
    this.cart_item = this.shoppingCartQuery.getEntity(cart_id);
    this.getFlowQuestions(this.cart_item?.flow_id, this.cart_item?.item_id, this.cart_item?.class_id);
  }

  getFlowQuestions(flow_id: any, item_id: any, class_id: any): any {
    this.flowPlayer.flowQuestions(flow_id, this.session_details?.category_id, this.session_details?.session_id, this.session_details?.group_id, item_id)
      .subscribe((questions: Question[]) => {
        if (!questions) {
          return;
        }

        if (questions?.length) {
          this.questions = [];
          this.childrenQuestions = [];
        }

        for (const q of questions) {
          if (q.answer && q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        this.loading = false;
      });
  }

  getQuestionChildren(question: Question): Question[] {
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  questionResponse(event): void {
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');
    } else {
      const questionIndex = this.questions?.findIndex(question => question.cent_aq_question_id === event.cent_aq_question_id);
      if (questionIndex > -1) {
        if (this.questions[questionIndex]?.answer === event?.answer) {
          return;
        }
        this.questions[questionIndex] = event;
        this.globalQuestionService.saveIndividualAnswer(this.questions[questionIndex], this.questions[questionIndex].item_id)
          .subscribe(() => {
            if (!this.isSavingData) {
              this.isSavingData = true;
              this.globalQuestionService.setSummaryDataObservable(true);
            }
          });
      }
    }
  }

  cancel() {
    this.router.navigate([`${RouterLinks.ClaimSummaryUpdate}`]);
  }

}
